<div class="card" [formGroup]="form">
    <div class="card-body">
      <h5 class="card-title">Curso</h5>

      <fieldset class="col-12">
        <legend>Busqueda</legend>
        <div class="card">
          <div class="card-body">
    
            <div class="form-row">
              <div class="form-group col-md-3">
                <label>Categoria</label>
                <select class="form-control" formControlName="cou_in_category">
                  <option value="0">Todos</option>
                  <ng-container *ngFor="let item of parameters">
                    <option *ngIf="item.sys_in_group == 500" [ngValue]="item.sys_in_parameter">{{item.sys_vc_description}}
                    </option>
                  </ng-container>
                </select>
              </div>
              <div class="form-group col-md-3">
                <label>Tipo de Duración</label>
                <select class="form-control" formControlName="cou_in_duration_type">
                  <option value="0">Todos</option>
                  <ng-container *ngFor="let item of parameters">
                    <option *ngIf="item.sys_in_group == 600" [ngValue]="item.sys_in_parameter">{{item.sys_vc_description}}
                    </option>
                  </ng-container>
                </select>
              </div>
              
              <div class="form-group col-md-2">
                <label>Estado</label>
                <select class="form-control" formControlName="cou_in_status">
                  <option value="0">Todos</option>
                  <ng-container *ngFor="let item of parameters">
                    <option *ngIf="item.sys_in_group == 1200" [ngValue]="item.sys_in_parameter">{{item.sys_vc_description}}
                    </option>
                  </ng-container>
                </select>
              </div>
    
              <div class="form-group col-md-2">
                <label class="col-md-12">&nbsp;</label>
                <button class="btn btn-badminton btn-sm pull-right" (click)="buscar()">Buscar Curso</button>
              </div>
              <div class="form-group col-md-2">
                <label class="col-md-12">&nbsp;</label>
                <button class="btn btn-badminton btn-sm pull-right" (click)="nuevo()">Nuevo Curso</button>
              </div>
              
    
            </div>
          </div>
        </div>
    
      </fieldset>

      
      <fieldset class="col-12">
      <legend>Listado</legend>
  
      <div class="card">
        <div class="card-body">
          
          <div class="mat-elevation-z8 table-responsive">
            <table mat-table [dataSource]="dataSource" matSort>
              <!-- Progress Column -->
              <ng-container matColumnDef="cou_vc_name">
                <th style="width: 40%;" mat-header-cell *matHeaderCellDef mat-sort-header> Curso </th>
                <td mat-cell *matCellDef="let row"> {{row.cou_vc_name}} </td>
              </ng-container>
          
              <!-- Name Column -->
              <ng-container matColumnDef="cou_in_duration">
                <th style="width: 12%;" mat-header-cell *matHeaderCellDef mat-sort-header> Duración </th>
                <td mat-cell *matCellDef="let row">{{row.cou_in_duration}} {{row.cou_vc_duration_type}}   </td>
              </ng-container>

              <ng-container matColumnDef="cou_vc_status">
                <th style="width: 12%;" mat-header-cell *matHeaderCellDef mat-sort-header> Estado </th>
                <td mat-cell *matCellDef="let row">{{row.cou_vc_status}}    </td>
              </ng-container>

              
              <ng-container matColumnDef="opcion">
                <th  style="width: 36%;" mat-header-cell *matHeaderCellDef> Opciones</th>
                <td  mat-cell *matCellDef="let element">
                  <a (click)="edit(element)" class="pr-2"><i class="fa fa-edit"></i> Editar</a>
                  

                  <ng-container *ngIf="element.cou_in_status == 1">
                    <a (click)="setEstado(2, element)" class="pr-2"><i class="fa fa-arrow-up"></i> Publicar</a>
                    <a (click)="setEstado(3, element)" class="pr-2"><i class="fa fa-arrow-down"></i> Eliminar</a>
                  </ng-container>

                  <ng-container *ngIf="element.cou_in_status == 2">
                    <a (click)="setEstado(1, element)" class="pr-2"><i class="fa fa-arrow-up"></i> Registrado</a>
                    <a (click)="setEstado(3, element)" class="pr-2"><i class="fa fa-arrow-down"></i> Eliminar</a>
                  </ng-container>
                 
                  <ng-container *ngIf="element.cou_in_status == 3">
                    <a (click)="setEstado(1, element)" class="pr-2"><i class="fa fa-arrow-up"></i> Registrado</a>
                    <a (click)="setEstado(2, element)" class="pr-2"><i class="fa fa-arrow-down"></i> Publicado</a>
                  </ng-container>

                  <a (click)="assign(element)" class="pr-2"><i class="fa fa-eye"></i> Detalle</a>

                </td>
              </ng-container>
  
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          
              <!-- Row shown when there is no matching data. -->
              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4">No data matching the filter</td>
              </tr>
            </table>
          
            <mat-paginator #paginatorDatasource [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
          </div>
  
        </div>
      </div>
  
      </fieldset>
    </div>
  </div>